module.exports = __webpack_public_path__ + "h5/img/logo2.909557ac.png";